import type { FeatureMetadata } from "../feature.types";

import { AccountsFeature } from "./accounts/accounts.feature";
import { AccountStatementFeature } from "./accounts/accountStatement/accountStatement.feature";
import { AddHeaderFeature } from "./accounts/addHeader/addHeader.feature";
import { DaybookFeature } from "./accounts/daybook/daybook.feature";
import { IncomeExpenditureFeature } from "./accounts/incomeExpenditure/incomeExpenditure.feature";
import { ChequesFeature } from "./chequeManagement/chequeManagement.feature";
import { ConcessionsFeature } from "./concessions/concessions.feature";
import { FeeSetupFeature } from "./feeSetup/feeSetup.feature";
import { FeeTypesFeature } from "./feeTypes/feeTypes.feature";
import { DailyPaymentSummaryFeature } from "./financeReports/dailyPaymentSummary/dailyPaymentSummary.feature";
import { FinanceReportsFeature } from "./financeReports/financeReports.feature";
import { OutstandingReportsFeature } from "./financeReports/outstandingReports/outstandingReports.feature";
import { PaidHistoryFeature } from "./financeReports/paidHistory/paidHistory.feature";
import { GatewaySettingsFeature } from "./gatewaySettings/gatewaySettings.feature";
import { LateFineRulesFeature } from "./lateFineRules/lateFineRules.feature";
import { LedgerToolsFeature } from "./ledgerTools/ledgerTools.feature";
import { OnlinePaymentsFeature } from "./onlinePayments/onlinePayments.feature";
import { PaymentsFeature } from "./payments/payments.feature";
import { RefundsFeature } from "./refunds/refunds.feature";

export {
  AccountStatementFeature,
  AccountsFeature,
  AddHeaderFeature,
  ChequesFeature,
  ConcessionsFeature,
  DailyPaymentSummaryFeature,
  DaybookFeature,
  FeeSetupFeature,
  FeeTypesFeature,
  FinanceReportsFeature,
  GatewaySettingsFeature,
  IncomeExpenditureFeature,
  LateFineRulesFeature,
  LedgerToolsFeature,
  OnlinePaymentsFeature,
  OutstandingReportsFeature,
  PaidHistoryFeature,
  PaymentsFeature,
  RefundsFeature,
};

export const FEES_FINANCE_FEATURES = [
  PaymentsFeature,
  AccountsFeature,
  AddHeaderFeature,
  IncomeExpenditureFeature,
  DaybookFeature,
  AccountStatementFeature,
  FeeSetupFeature,
  FeeTypesFeature,
  LateFineRulesFeature,
  ConcessionsFeature,
  GatewaySettingsFeature,
  OnlinePaymentsFeature,
  ChequesFeature,
  RefundsFeature,
  LedgerToolsFeature,
  FinanceReportsFeature,
  PaidHistoryFeature,
  DailyPaymentSummaryFeature,
  OutstandingReportsFeature,
] as const satisfies readonly FeatureMetadata[];
